import React from "react";

export default function About () {
    return (
        <section id="about">
            <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
                <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
                    <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
                        Hi, I'm Alina.
                        <br className="hidden lg:inline-block" /> I love learning new things and apply them in real life. I'm passionate about creating beauty in art, music and amazing
                        apps.
                    </h1>
                    <p className="mb-8 leading-relaxed">

                    </p>
                    <div className="flex justify-center">
                        <a
                            href="#contact"
                            className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
                            Work With Me
                        </a>
                        <a
                            href="#projects"
                            className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
                            See My Past Work
                        </a>
                    </div>
                </div>
                <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
                    <img
                        className="object-cover object-center rounded"
                        alt="hero"
                        src="./coding.png"
                    />
                </div>
                {/*<div className="mt-3 flex -space-x-6">*/}
                {/*    <i className="fab fa-github fa-3x inline-block h-11 w-11 rounded-full ring-2"></i>*/}
                {/*    <i className="fab fa-linkedin fa-3x inline-block h-11 w-11 rounded-full ring-2"></i>*/}
                {/*    <i className="fab fa-gitlab fa-3x inline-block h-12 w-12 rounded-full ring-2"></i>*/}
                {/*</div>*/}
            </div>
        </section>
    );
};


// WEBPACK FOOTER //
// ./src/component/About.js